import React from 'react';
import { Col, Row } from 'hui';
import styled from 'styled-components';
import facebookImage from '../images/facebook.svg';
import twitterImage from '../images/twitter.svg';
import pinterestImage from '../images/pinterest.svg';
import mailImage from '../images/mail.svg';
import { EventCategories, EventActions } from '../../../constants/Analytics';

export const SocialBarMobile = styled.div`
  .st-custom-button[data-network] {
    display: inline-block;
    padding: 5px;
    vertical-align: middle;
    img {
      cursor: pointer;
    }
  }
  .title {
    font-size: 16px;
    color: #2f3034;
    line-height: 26px;
    margin-right: 20px;
  }
`;

const SocialShareBarMobile = () => (
  <Row>
    <Col xs={12} md={0}>
      <SocialBarMobile>
        <span className="title">Share this article: </span>
        <div
          data-network="facebook"
          className="st-custom-button"
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
          data-ga-label="[Facebook]"
        >
          <img src={facebookImage} />
        </div>
        <div
          data-network="twitter"
          className="st-custom-button"
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
          data-ga-label="[Twitter]"
        >
          <img src={twitterImage} />
        </div>
        <div
          data-network="pinterest"
          className="st-custom-button"
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
          data-ga-label="[Pinterest]"
        >
          <img src={pinterestImage} />
        </div>
        <div
          data-network="email"
          className="st-custom-button"
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
          data-ga-label="[Email]"
        >
          <img src={mailImage} />
        </div>
      </SocialBarMobile>
    </Col>
  </Row>
);

export default SocialShareBarMobile;
